import { useComparer } from '@/hooks/useComparer';
import { ComparerParam } from '@/types/comparer';
import type { FC } from 'react';
import { getVisibleParams } from '../comparerUtils/comparerUtils';
import ModifiedProps from '../comparerShared/ModifiedProps';

type MetadataChangesProps = {
  metadata: ComparerParam[];
};

const MetadataChanges: FC<MetadataChangesProps> = ({ metadata }) => {
  const { showUnchanged } = useComparer();

  const visibleMetadata = getVisibleParams(metadata, showUnchanged);

  return (
    <>
      {visibleMetadata.map((metadataRow) => (
        <ModifiedProps key={metadataRow.key} param={metadataRow} />
      ))}
    </>
  );
};

export default MetadataChanges;
